<template>
    <div class="main-container w-full min-h-[90vh] bottom-8">
        <div class="fixed top-0 w-full z-50">
            <div class="z-50 relative">
                <NavBar :title="title" @minimize="minimize" @close="close"/>
            </div> 
            <div class="z-40 relative">
                <NavBarINV @openPage="selectTab"/>
            </div>
            <div class="z-30">
                <PagesTab @openPage="selectedTab" @closePage="closeTab"/>
            </div>
        </div>
        <div class="tab-content z-20 overflow-y-hidden">
            <keep-alive :include="cachedComponents">
                <component 
                    :is="activeComponent"
                 />
            </keep-alive>
        </div>
        
    </div>
</template>

<script>
import { useStore } from 'vuex';
import { ref, computed, watch } from 'vue';
import NavBar from '@/components/NavBar.vue'
import NavBarINV from '@/components/INV/NavBarINV.vue';
import PagesTab from '@/components/INV/PagesTab.vue';
import Dashboard from '@/components/INV/Dashboard.vue';
import Item_Categories from '@/components/INV/Item_Categories.vue';
import Items_Catalog from '@/components/INV/Items_Catalog.vue';
import Import_Item_Catalog from '@/components/INV/Import_Item_Catalog.vue';
import Item_Details from '@/components/INV/Item_Details.vue';
import Retail_Outlets from '@/components/INV/Retail_Outlets.vue';
import Catalog_By_Outlet from '@/components/INV/Catalog_By_Outlet.vue';
import Fast_Moving_Items from '@/components/INV/Fast_Moving_Items.vue';
import Item_Location from '@/components/INV/Item_Location.vue';
import Uom from '@/components/INV/Uom.vue';
import Outlet_Counters from '@/components/INV/Outlet_Counters.vue';
import Counter_Channels from '@/components/INV/Counter_Channels.vue';
import Direct_Sales from '@/components/INV/Direct_Sales.vue';
import Sale_Details from '@/components/INV/Sale_Details.vue';
import Sale_Items from '@/components/INV/Sale_Items.vue';
import General_Invoices from '@/components/FA/General_Invoices.vue';
import Invoice_Details from '@/components/FA/Invoice_Details.vue';
import General_Receipts from '@/components/FA/General_Receipts.vue';
import Receipt_Details from '@/components/FA/Receipt_Details.vue';
import Customers from '@/components/FA/Customers.vue';
import Debtor_Statement from '@/components/FA/Debtor_Statement.vue';
import General_Bills from '@/components/FA/General_Bills.vue';
import Bill_Details from '@/components/FA/Bill_Details.vue';
import Payment_Vouchers from '@/components/FA/Payment_Vouchers.vue';
import Payment_Details from '@/components/FA/Payment_Details.vue';
import Vendors from '@/components/FA/Vendors.vue';
import Vendor_Statement from '@/components/FA/Vendor_Statement.vue';
import Sale_Orders from '@/components/INV/Sale_Orders.vue';
import Sale_Order_Details from '@/components/INV/Sale_Order_Details.vue';
import Delivery_Orders from '@/components/INV/Delivery_Orders.vue';
import Delivery_Order_Details from '@/components/INV/Delivery_Order_Details.vue';
import Direct_Purchases from '@/components/INV/Direct_Purchases.vue';
import Purchase_Details from '@/components/INV/Purchase_Details.vue';
import Purchase_Items from '@/components/INV/Purchase_Items.vue';
import Purchase_Orders from '@/components/INV/Purchase_Orders.vue';
import Purchase_Order_Details from '@/components/INV/Purchase_Order_Details.vue';
import Received_Orders from '@/components/INV/Received_Orders.vue';
import Received_Order_Details from '@/components/INV/Received_Order_Details.vue';
import Stock_Adjustments from '@/components/INV/Stock_Adjustments.vue';
import Stock_Adjustment_Details from '@/components/INV/Stock_Adjustment_Details.vue';
import Stock_Transfers from '@/components/INV/Stock_Transfers.vue';
import Stock_Transfer_Details from '@/components/INV/Stock_Transfer_Details.vue';
import Recipes from '@/components/INV/Recipes.vue';
import Recipe_Details from '@/components/INV/Recipe_Details.vue';
import Production_Batches from '@/components/INV/Production_Batches.vue';
import Production_Details from '@/components/INV/Production_Details.vue';
import Product_History from '@/components/INV/Product_History.vue';
import Item_Batches from '@/components/INV/Item_Batches.vue';

import Default_Settings from '@/components/SET/Default_Settings.vue';

export default{
    components:{
        NavBar,
        NavBarINV,
        PagesTab,
        Dashboard,Item_Categories,Items_Catalog,Import_Item_Catalog,Item_Details,Retail_Outlets,Catalog_By_Outlet,Fast_Moving_Items,Item_Location,Uom,
        Outlet_Counters,Direct_Sales,Sale_Details,Sale_Items,General_Invoices,Invoice_Details,General_Receipts,Receipt_Details,Customers,General_Bills,
        Bill_Details,Payment_Vouchers,Payment_Details,Vendors,Sale_Orders,Sale_Order_Details,Delivery_Orders,Delivery_Order_Details,Direct_Purchases,
        Purchase_Details,Purchase_Items,Purchase_Orders,Purchase_Order_Details,Counter_Channels,Received_Orders,Received_Order_Details,
        Stock_Adjustments,Stock_Transfers,Stock_Transfer_Details,Stock_Adjustment_Details,Debtor_Statement,Vendor_Statement,Recipes,Recipe_Details,
        Production_Batches,Production_Details,Product_History,Item_Batches,

        Default_Settings
    },
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    setup(){
        const store = useStore();
        const title = ref('Inventory Management');
        const cachedComponents = computed(() =>  Array.from(store.state.pageTab.invArray));
        const tabs = computed({
            get: ()=> store.state.pageTab.invArray,
        });

        const activeTab = computed(() => store.state.pageTab.invActiveTab);
    
        const activeComponent = computed(() => activeTab.value);
    
        const selectTab = (pageName) => {
            for(const [key, value] of Object.entries(pageName)){
                store.state.pageTab.invActiveTab = value;
            }
        };
        const selectedTab = (pageName) => {
            store.state.pageTab.invActiveTab = pageName;
        };
        const closeTab = (pageName) =>{
            let page = {"INV":pageName};
            store.commit('pageTab/REMOVE_PAGE', page)
            store.commit(`${pageName}/RESET_SEARCH_FILTERS`)
            activeTab.value = store.state.pageTab.invActiveTab;
            store.commit(`${pageName}/initializeStore`);
        }
        const minimize = () =>{
            store.commit('modulesTab/MINIMIZE_TAB')
        }
        const close = () =>{
            let myArray = Array.from(tabs.value);
            for(let i=0; i<myArray.length; i++){
                store.commit(`${myArray[i]}/RESET_SEARCH_FILTERS`)
                store.commit(`${myArray[i]}/initializeStore`)
            }
            store.commit('modulesTab/REMOVE_TAB', {'INV':'Inventory Management'}),
            store.commit('pageTab/CLEAR_PAGE_TAB', 'Inventory Management');
            activeTab.value = store.state.pageTab.invActiveTab;
        }
        return{
            close,minimize,title,activeComponent,selectTab, selectedTab, closeTab,activeTab, cachedComponents
        }
    },
    mounted(){
        const store = useStore();
        this.activeTab = store.state.pageTab.invActiveTab;
    }
}
</script>

<style>
.tab-content{
    margin-top: 35px;
}
.main-container{
    max-height: 100vh;
    overflow: hidden;
}

</style>